import { Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-credit-card-animation',
	templateUrl: './credit-card-animation.component.html',
	styleUrls: ['./credit-card-animation.component.scss']
})
export class CreditCardAnimationComponent implements OnInit, DoCheck {

	@Input() form: FormGroup;
	cardNumber = {
		one: '****',
		two: '****',
		tree: '****',
		four:'****',
		five: '****'
	}

	expDate = {
		month: 'MM',
		year: 'YY'
	}

	name = {
		first: 'NAME',
		last: 'LAST'
	}

	constructor() { }
	ngDoCheck(): void {
		this.getCardNumber();
		this.getExpDate();
		this.getFirstName();
		this.getLastName();
	}



	ngOnInit() {
	}

	getCardNumber(){
		let number = this.form.get('cardNumber').value;

		if(number.length < 1 ){
			this.cardNumber.one = '****';
		} else if(number.length <= 4 ){
			this.cardNumber.one = number;
			this.cardNumber.two = '****';
			this.cardNumber.tree = '****';
			this.cardNumber.four = '****';
			this.cardNumber.five = '****';

		}
		if(number.length > 4 && number.length <= 8){
			this.cardNumber.one = number.slice(0, 4);
			this.cardNumber.two = number.slice(4,number.length);
			this.cardNumber.tree = '****';
			this.cardNumber.four = '****';
			this.cardNumber.five = '****';
		}
		if(number.length > 8 && number.length <= 12){
			this.cardNumber.one = number.slice(0, 4);
			this.cardNumber.two = number.slice(4, 8);
			this.cardNumber.tree = number.slice(8, number.length);
			this.cardNumber.four = '****';
			this.cardNumber.five = '****';
		}
		if(number.length > 12 && number.length <= 16){
			this.cardNumber.one = number.slice(0, 4);
			this.cardNumber.two = number.slice(4, 8);
			this.cardNumber.tree = number.slice(8, 12);
			this.cardNumber.four = number.slice(12, number.length);
			this.cardNumber.five = '****';
		}
		if(number.length > 16 && number.length <= 20){
			this.cardNumber.one = number.slice(0, 4);
			this.cardNumber.two = number.slice(4, 8);
			this.cardNumber.tree = number.slice(8, 12);
			this.cardNumber.four = number.slice(12, 16);
			this.cardNumber.five = number.slice(16, number.length);
		}
	}

	getFirstName(){
		if(this.form.get('firstName').value.length < 1 ){
			this.name.first = 'NAME';
		} else {
			this.name.first = this.form.get('firstName').value;
		}

	}

	getLastName(){
		if(this.form.get('lastName').value.length < 1 ){
			this.name.last = 'LAST';
		} else {
			this.name.last = this.form.get('lastName').value;
		}

	}

	getExpDate(){
		if(this.form.get('expMonth').value.length < 1 ){
			this.expDate.month = 'MM';
		} else {
			this.expDate.month = this.form.get('expMonth').value;
		}

		if(this.form.get('expYear').value.length < 1 ){
			this.expDate.year = 'YY';
		} else {
			this.expDate.year = this.form.get('expYear').value;
		}
	}

}
